import React from 'react';
import { Container, Row, Col, Form, Button, Card, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPlus, faGuitar, faDrum } from '@fortawesome/free-solid-svg-icons';
import '../components/components.css';

const BeatsChords = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2 className="mb-4">Beats + Chords Generator</h2>
      
      <Row>
        <Col lg={8}>
          <Card className="mb-4 beats-card">
            <Card.Body>
              <Form>
                <h5 className="mb-3">Chord Progression Generator</h5>
                <Row className="mb-3">
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Key</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>C major</option>
                        <option>G major</option>
                        <option>D major</option>
                        <option>A major</option>
                        <option>E major</option>
                        <option>A minor</option>
                        <option>E minor</option>
                        <option>B minor</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Chord Complexity</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Basic (Triads)</option>
                        <option>Intermediate (7ths)</option>
                        <option>Advanced (Extensions)</option>
                        <option>Jazz (Complex Voicings)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Length</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>4 bars</option>
                        <option>8 bars</option>
                        <option>16 bars</option>
                        <option>32 bars</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Style</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Pop</option>
                        <option>R&B</option>
                        <option>Hip Hop</option>
                        <option>EDM</option>
                        <option>Rock</option>
                        <option>Jazz</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Chord Feel</Form.Label>
                      <div className="d-flex">
                        <Button variant="outline-secondary" className="me-2 flex-grow-1 beats-btn-outline">Happy</Button>
                        <Button variant="outline-secondary" className="me-2 flex-grow-1 beats-btn-outline">Melancholic</Button>
                        <Button variant="outline-secondary" className="me-2 flex-grow-1 beats-btn-outline">Epic</Button>
                        <Button variant="outline-secondary" className="flex-grow-1 beats-btn-outline">Chill</Button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                
                <h5 className="mt-4 mb-3">Beat Settings</h5>
                <Row className="mb-3">
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Tempo (BPM)</Form.Label>
                      <Form.Range min="60" max="180" defaultValue="120" />
                      <div className="d-flex justify-content-between">
                        <small className="beats-form-text">60</small>
                        <small className="beats-form-text">120</small>
                        <small className="beats-form-text">180</small>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group>
                      <Form.Label className="beats-form-label">Drum Kit</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Trap Kit</option>
                        <option>Acoustic Kit</option>
                        <option>Electronic Kit</option>
                        <option>Lo-Fi Kit</option>
                        <option>808 Kit</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                <div className="d-grid mt-4">
                  <Button variant="primary" size="lg" className="beats-btn-primary">
                    Generate Beats & Chords
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={4}>
          <Card className="beats-card">
            <Card.Header className="bg-purple-medium">
              Recent Generations
            </Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item className="beats-list-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="fw-bold">Chill Pop Progression</div>
                    <small className="beats-form-text">C major • 120 BPM</small>
                  </div>
                  <Button variant="dark" size="sm" className="rounded-circle">
                    <FontAwesomeIcon icon={faPlay} />
                  </Button>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="beats-list-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="fw-bold">Trap Beat in G minor</div>
                    <small className="beats-form-text">G minor • 140 BPM</small>
                  </div>
                  <Button variant="dark" size="sm" className="rounded-circle">
                    <FontAwesomeIcon icon={faPlay} />
                  </Button>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="beats-list-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="fw-bold">R&B Jazz Fusion</div>
                    <small className="beats-form-text">D minor • 95 BPM</small>
                  </div>
                  <Button variant="dark" size="sm" className="rounded-circle">
                    <FontAwesomeIcon icon={faPlay} />
                  </Button>
                </div>
              </ListGroup.Item>
            </ListGroup>
            <Card.Footer>
              <Button variant="outline-primary" className="w-100 beats-btn-outline">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                View Library
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BeatsChords; 